import type React from 'react';
import { useContext, useState } from 'react';
import { ConfigContext } from '../../context/ConfigContext';
import PoweredBy from '../PoweredBy';
import { MicrosoftSignIn } from './MicrosoftSignIn';

export const MicrosoftSSOBlocker: React.FC = () => {
  const {
    scheme: {
      message: { buttonEdgeColor, buttonTextColor, buttonHoverColor },
    },
  } = useContext(ConfigContext);
  const [hover, setHover] = useState(false);

  return (
    <div className='chat-window-blocker-container'>
      <p className='chat-window-blocker-text'>
        {'Sign in with Microsoft to continue'}
      </p>
      <MicrosoftSignIn
        buttonEdgeColor={buttonEdgeColor}
        buttonTextColor={buttonTextColor}
        buttonHoverColor={buttonHoverColor}
        hover={hover}
        onHoverChange={setHover}
      />
      <PoweredBy />
    </div>
  );
};
